import { render, staticRenderFns } from "./Add_file_promotion_internet.vue?vue&type=template&id=937ec55a&"
import script from "./Add_file_promotion_internet.vue?vue&type=script&lang=js&"
export * from "./Add_file_promotion_internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports